import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewTabSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1422_5920)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.13574 12.75L2.69827 7.54393C2.73305 7.42805 2.80439 7.32653 2.90164 7.25454C2.99888 7.18256 3.11681 7.14397 3.23779 7.14454H9.12354C9.24452 7.14397 9.36245 7.18256 9.45969 7.25454C9.55694 7.32653 9.62828 7.42805 9.66306 7.54393L11.2256 12.75",
				stroke: "black",
				strokeWidth: 1.12109,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7861 7.14454H12.4868C12.6078 7.14397 12.7257 7.18256 12.823 7.25454C12.9202 7.32653 12.9916 7.42805 13.0263 7.54393L14.5889 12.75",
				stroke: "black",
				strokeWidth: 1.12109,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1499 7.14454H15.8506C15.9716 7.14397 16.0895 7.18256 16.1867 7.25454C16.284 7.32653 16.3553 7.42805 16.3901 7.54393L17.9526 12.75",
				stroke: "black",
				strokeWidth: 1.12109,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.13574 12.75H17.9521",
				stroke: "black",
				strokeWidth: 1.12109,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1422_5920",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 17.9375,
			height: 17.9375,
			fill: "white",
			transform: "translate(0.574707 0.976562)"
		})
	}) })]
});
export default SvgNewTabSymbol;
